<template>
  <button
    type="button"
    role="switch"
    :aria-checked="value ? 'true' : 'false'"
    :aria-label="label"
    :disabled="disabled"
    class="relative inline-flex h-6 w-11 flex-none items-center rounded-full border transition"
    :class="trackClass"
    @click="toggle"
  >
    <span
      class="inline-block h-4 w-4 transform rounded-full transition"
      :class="knobClass"
    ></span>
  </button>
</template>

<script>
export default {
  name: "Toggle",
  model: { prop: "value", event: "change" },
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // Used as the accessible name when the visible label sits elsewhere.
    label: { type: String, default: "" },
  },

  computed: {
    trackClass() {
      if (this.disabled) {
        return "bg-primary-700 border-primary-400 opacity-50 cursor-not-allowed";
      }
      return this.value
        ? "bg-highlight border-highlight"
        : "bg-primary-700 border-primary-400";
    },
    knobClass() {
      // The knob moves *and* the track changes colour, so the state is never
      // carried by colour alone.
      return this.value
        ? "translate-x-6 bg-primary-700"
        : "translate-x-1 bg-subtle";
    },
  },

  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("change", !this.value);
    },
  },
};
</script>
